export const UBICATION_LOCATION = 'vivienda/location/UBICATION_LOCATION'

export function fetchUbication(data) {
    return {
        type: UBICATION_LOCATION,
        payload: data
    }
}